import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import { PantoneColorPicker } from 'swag-client-common/components/pickers/pantone-color-picker';
import Loading from 'swag-client-common/components/info/loading';
import Image from 'swag-client-common/components/ui/image';
import { convertToOneColorPopupSelector } from '../../../redux/logo-editing/logo-editing.selectors';
import { convertToOneColorDispatcher } from '../../../redux/logo-editing/logo-editing.dispatchers';
import classes from './convert-to-one-color-popup.scss';
const dialogBackgroundColor = '#F8F9FA';
const title = () => /*#__PURE__*/React.createElement("div", {
  className: classes.title
}, /*#__PURE__*/React.createElement("div", {
  className: classes['title-content']
}, /*#__PURE__*/React.createElement("h2", null, "Convert design to one color")));
export function ConvertToOneColorPopup({
  preview,
  loading,
  convertTo,
  variantColor,
  isButtonDisabled,
  isRevertButtonShown,
  onRevertOriginalPreviewClick,
  onContinueClick,
  onColorChange,
  colors,
  onClose
}) {
  const content = /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.whiteColumn, classes.column)
  }, title(), /*#__PURE__*/React.createElement("div", {
    className: classes.colorsHeader
  }, "Select design color"), /*#__PURE__*/React.createElement(PantoneColorPicker, {
    colors: colors,
    selected: convertTo,
    onExactPantonesChange: onColorChange,
    onColorClick: onColorChange,
    isConvertingMode: true
  }), isRevertButtonShown && /*#__PURE__*/React.createElement("button", {
    className: classes.buttonRevert,
    onClick: onRevertOriginalPreviewClick
  }, "Revert to original preview"), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isButtonDisabled,
    className: classes.buttonContinue,
    type: "primary",
    size: "normal",
    onClick: onContinueClick
  }, "Confirm"))), /*#__PURE__*/React.createElement("div", {
    style: {
      background: variantColor
    },
    className: classnames(classes.column, classes.previewColumn)
  }, loading ? /*#__PURE__*/React.createElement(Loading, null) : /*#__PURE__*/React.createElement(Image, {
    src: preview,
    className: classes.logo,
    style: {
      background: variantColor
    },
    alt: "preview"
  })));
  return /*#__PURE__*/React.createElement(ControlDialog, {
    content: content,
    modal: true,
    open: true,
    showCloseButton: true,
    onRequestClose: onClose,
    dialogClass: classes.dialogClass,
    titleStyle: {
      backgroundColor: dialogBackgroundColor
    },
    bodyStyle: {
      backgroundColor: dialogBackgroundColor,
      padding: '0'
    },
    bodyClassName: classes.popupBody,
    actionsContainerStyle: {
      padding: '0'
    },
    contentClassName: classes.wrapper
  });
}
export default connect(convertToOneColorPopupSelector, convertToOneColorDispatcher)(ConvertToOneColorPopup);